import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWorkflowModel, WorkflowPartnerComponent } from '../workflow-partner.component';
import { Block } from 'src/app/phonenumber/phonenumber.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { BuyService } from 'src/app/buy/buy.service';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { MessageService } from 'primeng/api';
import { I18NextService } from 'angular-i18next';
import { CompanyService } from 'src/app/company/company.service';
import { WorkflowPartnerService } from '../workflow-partner.service';
import { PhonenumberService } from 'src/app/phonenumber/phonenumber.service';
import { HttpClient } from '@angular/common/http';
import { CustomerService } from 'src/app/customer/customer.service';
import { Company, Contact } from 'src/app/company/company.model';
import { runInAction } from 'mobx';
import { PaymentDetails, SaleOrder } from 'src/app/buy/buy.model';
import { firstValueFrom } from 'rxjs';

type WorkflowModel = BaseWorkflowModel & {
  block: Block
}

@Component({
  selector: 'app-workflow-partner-one-cancel-phonenumber',
  templateUrl: './workflow-partner-one-cancel-phonenumber.component.html',
  standalone: false
})
export class WorkflowPartnerOneCancelPhonenumberComponent extends WorkflowPartnerComponent<WorkflowModel> implements OnInit, OnDestroy {

  get workflowName(): string {
    return 'cancel-phonenumber';
  }

  private blockId = 0;

  constructor(protected router: Router,
    protected m: Model,
    protected route: ActivatedRoute,
    protected buyService: BuyService,
    protected subscriptionService: SubscriptionService,
    protected messageService: MessageService,
    protected i18next: I18NextService,
    protected companyService: CompanyService,
    protected partnerService: WorkflowPartnerService,
    protected phonenumberService: PhonenumberService,
    protected customerService: CustomerService,
    protected http: HttpClient) {
    super(route, router, subscriptionService, buyService, m, http, partnerService, companyService, customerService);
  }

  async ngOnInit() {
    await super.ngOnInit();

    if (!this.checkSubscriptionValid) {
      this.resetWorkflow();
      return;
    }

    await this.loadPartnerContext();

    this.blockId = +(this.route.snapshot.paramMap.get('bid') ?? 0);
    const block = this.m.phonenumber.blocks.find(block => block.id === this.blockId);
    if (!block) {
      this.resetWorkflow();
      return;
    }
    this.model.block = block;

    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  // step 1: confirm cancellation
  public onCancellationConfirmed(s: any) {
    this.navigate([this.blockId, 'contact']);
  }

  // step 2 - select a Contact
  public onContactBack() {
    this.navigate([this.blockId, 'confirm']);
  }

  public onContact(c: Contact) {
    runInAction(() => {
      this.model.contact = c;
    });
    this.navigate([this.blockId, 'address']);
  }
    
  // step 3: invoice address
  public onInvoiceAddressBack() {
    this.navigate([this.blockId, 'contact']);
  }
  
  public onInvoiceAddress(company: Company) {
    this.model.company = company;
    if (this.isSepa && !this.model.company.hasBankAccount) {
      this.navigate([this.blockId, 'payment']);
      return;
    }
    this.createOrderAndCheckout();
  }
  
  // step 4: payment
  public onPaymentMethodBack() {
    this.navigate([this.blockId, 'address']);
  }
  
  public async onPaymentMethod(payment: PaymentDetails) {
    await this.setPaymentDetails(payment);
    this.createOrderAndCheckout();
  }

  private async createOrderAndCheckout() {
    await this.createOffer();
    this.navigate([this.blockId, 'checkout-summary']);
  }

  private async createOffer() {
    // if a saleOrder exists --> return, otherwise create one
    if (this.model.saleOrder?.name) {
      return;
    }

    const saleOrder = await firstValueFrom(this.workflowPartnerService.oneApplianceCreateCancelPhonenumberOrder(this.model.subscription?.appliance_id, this.blockId, this.model.contact?.id));
    runInAction(() => {
      this.model.saleOrder = saleOrder;
    });
  }

  // step : 5 confirm order
  public onSummaryBack() {
    if (this.isSepa && !this.model.company?.hasBankAccount) {
      this.navigate([this.blockId, 'payment']);
    } else {
      this.navigate([this.blockId, 'address']);
    }
  }

  public async onSummaryBuy() {
    await firstValueFrom(this.buyService.confirmPartnerQuotation()).then(
      (saleOrder: any) => {
        this.navigate([this.blockId, 'complete']);
      }
    );
  }

}
